import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { Namespace } from '../../translation/namespace';
import { AttachedFilesBlock } from '../../_blocks/AttachedFiles/AttachedFilesBlock';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';

export type AttachedFilesWidget = ContextWidget<AttachedFilesBlock, WidgetType.attachedfiles>;

export function AttachedFilesWidget(props: AttachedFilesWidget) {
  const { t } = useTranslation(Namespace.AttachedFiles);

  return <DefaultContextWidget icon={Icons.ATTACHED_FILES} title={t('widgetTitle')} {...props} />;
}
